module.exports = __webpack_public_path__ + "static/o-t-03-a8163f385b80bfe1b964076884be8771.jpg";